
        var result = require("!!../../../../node_modules/css-loader/index.js!./stock-inventory.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/stock/stock-inventory/stock-inventory.component.css
// module id = 2474
// module chunks = 1